module.exports = __webpack_public_path__ + "fonts/Roboto-100-cyrillic10.9405b53.woff2";